/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsLockoutInfo } from "../../entities/models/LockoutInfo";
import { z } from "zod/v4";

export const modelsLockoutInfoSchema = z.object({
    "attempts_left": z.optional(z.int()),
"is_locked": z.optional(z.boolean()),
"locked_until": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsLockoutInfo>